import {
    CORE_LOAD_ROLES_REQUEST,
    CORE_LOAD_ROLES_SUCCESS,

    CORE_LOAD_ROLE_INFO_REQUEST,
    CORE_LOAD_ROLE_INFO_SUCCESS,
} from '../../types'

const initialState = []
export default {
    roles: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ROLES_REQUEST:
                return initialState
            case CORE_LOAD_ROLES_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    role: (state = {}, action) => {
        switch (action.type) {
            case CORE_LOAD_ROLE_INFO_REQUEST:
                return initialState
            case CORE_LOAD_ROLE_INFO_SUCCESS:
                return action.payload

            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/features/roles/reducer.js